import { render, staticRenderFns } from "./ReceptionActivity.vue?vue&type=template&id=34196d81&scoped=true"
import script from "./ReceptionActivity.vue?vue&type=script&lang=js"
export * from "./ReceptionActivity.vue?vue&type=script&lang=js"
import style0 from "./ReceptionActivity.vue?vue&type=style&index=0&id=34196d81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34196d81",
  null
  
)

export default component.exports